module.exports = __webpack_public_path__ + "6d713ef9d19d0ce090e39b1b9a2fd3e8.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/LS.svg
// module id = BqBA
// module chunks = 0